import { HTMLAttributes, MouseEventHandler } from "react";
import { cn } from "@util/helpers";

import SplideNextArrow from "./SplideNextArrow";
import SplidePrevArrow from "./SplidePrevArrow";

type SplideArrowsProps = Pick<HTMLAttributes<HTMLDivElement>, "className"> & {
  /** additional function to handle click events */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** Optional additional styling for the previous arrow */
  prevArrowClassName?: string;
  /** Optional additional styling for the next arrow */
  nextArrowClassName?: string;
};

export default function SplideArrows({
  className,
  onClick,
  prevArrowClassName,
  nextArrowClassName,
}: SplideArrowsProps): React.ReactElement {
  return (
    <div className={cn("splide__arrows", className)}>
      <SplidePrevArrow onClick={onClick} className={prevArrowClassName} />

      <SplideNextArrow onClick={onClick} className={nextArrowClassName} />
    </div>
  );
}
